import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Course, Obstacle, Run, FirestoreReference } from 'src/app/Classes/schema';
import { Observable, Subscription } from 'rxjs';
import { AnwService } from 'src/app/Services/ANW/anw.service';
import { MatDialog } from '@angular/material/dialog';
import { NewRunComponent } from '../run/new-run/new-run.component';
import { NewObstacleComponent } from '../obstacle/new-obstacle/new-obstacle.component';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit, OnDestroy {
  runs: FirestoreReference<Run>[];
  course: FirestoreReference<Course>
  obstacles: FirestoreReference<Obstacle>[];

  runs$: Subscription;
  course$: Subscription;
  obstacles$: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private anw: AnwService,
    private dialog: MatDialog
  ) {
    console.log("Course loaded");
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const courseId = params.get("courseId");
      
      this.course$ = this.anw.getCourse(courseId).subscribe(ref => {
        this.anw.log("-- course comes in through subscription");
        this.course = ref;
      });
      this.course = this.anw.initCourse();

      this.runs = this.anw.initRuns();
      this.runs$ = this.anw.getRuns(courseId).subscribe(refs => this.runs = refs);

      this.obstacles = this.anw.initObstacles();
      this.obstacles$ = this.anw.getObstacles(courseId).subscribe(refs => this.obstacles = refs);
    }).unsubscribe();
  }

  modalData = () => ({ width: '500px', data: { course: this.course } });
  openModal = (component: any) => this.dialog.open(component, this.modalData());

  runModal = () => this.openModal(NewRunComponent)
    .afterClosed()
    .toPromise()
    .then(ninjaId => this.runs.find(ref => ref.data.ninjaId === ninjaId).id)
    .then(id => {
      this.router.navigate(['./run', id], { relativeTo: this.route, skipLocationChange: true });
    });

  obstacleModal = () => { this.openModal(NewObstacleComponent) };

  ngOnDestroy() {
    console.log("Unsubscribing");
    this.runs$.unsubscribe();
    this.course$.unsubscribe();
    this.obstacles$.unsubscribe();
  }
}
